import { Location } from "react-router-dom-v5-compat";

import { createSearchParams, Filters } from "features/course-discovery/utils";

export function linkToAnonymousCourseDiscoveryPage() {
  return `/courses`;
}

export const linkToAnonymousCourseDiscoveryPageWithFilters = (
  filters: Filters,
  text?: string
): Location => {
  return {
    pathname: linkToAnonymousCourseDiscoveryPage(),
    search: createSearchParams(filters, text),
    state: undefined,
    hash: "",
    key: ""
  };
};

export const linkToAnonymousCourseDiscoveryWithDefaultFilters = () =>
  linkToAnonymousCourseDiscoveryPageWithFilters({});
